// C&M v6 (Shopify-Theme): Warenkorb über /cart/add.js, Formular, Filter, Preise ohne MwSt., Einblenden. Ohne JavaScript bleibt alles bedienbar.
(function () {
  var ruhig = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
  var WURZEL = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function fmt(n) { return (Math.round(n * 100 + 1e-6) / 100).toFixed(2).replace(".", ",") + " €"; }  // kaufmännisch runden (Gleitkomma: 1.785 -> 1,79)
  function tick() { try { navigator.vibrate && navigator.vibrate(8); } catch (e) {} }
  function toast(t) {
    var el = document.getElementById("toast"); if (!el) return;
    el.textContent = t; el.classList.add("an"); clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove("an"); }, 1800);
  }
  function badge(n, hupfen) {
    var bd = document.getElementById("badge"); if (!bd) return;
    bd.textContent = n; bd.classList.toggle("an", n > 0);
    if (hupfen && !ruhig) { bd.classList.remove("hupf"); void bd.offsetWidth; bd.classList.add("hupf"); }
  }
  function korbHolen() { return fetch(WURZEL + "cart.js", {headers: {"Accept": "application/json"}}).then(function (r) { return r.json(); }); }
  // items: [{id: Varianten-ID, quantity: n}]
  function hinzu(items, meldung, knopf) {
    if (knopf) knopf.disabled = true;
    return fetch(WURZEL + "cart/add.js", {method: "POST", headers: {"Content-Type": "application/json", "Accept": "application/json"}, body: JSON.stringify({items: items})})
      .then(function (r) { return r.json().then(function (d) { return {ok: r.ok, d: d}; }); })
      .then(function (x) {
        if (!x.ok) { toast(x.d.description || x.d.message || "Konnte nicht in den Warenkorb legen"); return false; }
        tick(); toast(meldung);
        return korbHolen().then(function (k) { badge(k.item_count, true); return true; });
      })
      .catch(function () { toast("Keine Verbindung – bitte noch einmal versuchen"); return false; })
      .then(function (ok) { if (knopf) knopf.disabled = false; return ok; });
  }
  document.addEventListener("click", function (e) {
    var plus = e.target.closest(".plus[data-v]");
    if (plus) {
      e.preventDefault();
      hinzu([{id: +plus.dataset.v, quantity: 1}], plus.dataset.n + " · im Warenkorb", null).then(function (ok) {
        if (!ok) return;
        plus.classList.add("ok"); var alt = plus.innerHTML;
        plus.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-10"/></svg>';
        setTimeout(function () { plus.classList.remove("ok"); plus.innerHTML = alt; }, 1300);
      });
      return;
    }
    if (e.target.closest(".menue .panel a")) { var mm = document.querySelector(".menue"); if (mm) mm.removeAttribute("open"); }
  });
  // Produktseite: echtes Formular (/cart/add), mit JavaScript ohne Seitenwechsel
  document.querySelectorAll("form.produkt-form").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var m = Math.max(1, parseInt(f.elements.quantity && f.elements.quantity.value, 10) || 1);
      hinzu([{id: +f.elements.id.value, quantity: m}], (f.dataset.n || "Produkt") + " · im Warenkorb", f.querySelector("[type=submit]"));
    });
  });
  // Anfrageformular (Shopify-Kontaktformular): Firma und E-Mail sind Pflicht (Shopify verlangt die E-Mail)
  var form = document.getElementById("anfrage");
  if (form) form.addEventListener("submit", function (e) {
    var f = form.elements, hinweis = document.getElementById("form-hinweis");
    var firma = f["contact[Firma]"], mail = f["contact[email]"];
    var fehler = (firma && !firma.value.trim()) ? "Bitte Firma angeben." : (!mail.value.trim()) ? "Bitte E-Mail angeben." :
      (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(mail.value)) ? "Bitte E-Mail prüfen." : "";
    if (fehler) { e.preventDefault(); hinweis.hidden = false; hinweis.textContent = fehler; }
  });
  // Bedarf aus dem Warenkorb vorbelegen (wie v6), nur wenn das Feld leer ist
  var bedarf = document.getElementById("bedarf");
  var qb = (location.search.match(/[?&]bedarf=([^&]*)/) || [])[1];
  if (bedarf && qb && !bedarf.value) { try { bedarf.value = decodeURIComponent(qb.replace(/\+/g, " ")); } catch (e) {} }
  if (bedarf && !bedarf.value) korbHolen().then(function (k) {
    if (!bedarf.value && k.items && k.items.length) bedarf.value = k.items.map(function (i) { return i.quantity + " × " + i.product_title.replace(/^CM\s+/, "") + (i.sku ? " (Art.-Nr. " + i.sku + ")" : ""); }).join("\n");
  }).catch(function () {});
  // Kategorie aus der Adresse
  var kat = (location.search.match(/[?&]kategorie=([a-z]+)/) || [])[1];
  if (kat) { var r = document.getElementById("sk-" + kat); if (r) r.checked = true; }
  // Preise ohne MwSt. (nur Anzeige: Preis / 1,19; Warenkorb und Kasse bleiben inkl. MwSt.)
  var netto = false; try { netto = localStorage.getItem("cm_netto") === "1"; } catch (e) {}
  function preise() {
    document.querySelectorAll("[data-b]").forEach(function (el) {
      var b = parseFloat(el.dataset.b); el.textContent = fmt(netto ? b / 1.19 : b) + (el.dataset.e || "");
    });
    document.querySelectorAll(".mwst").forEach(function (el) { el.textContent = netto ? "zzgl. 19 % MwSt." : "inkl. MwSt."; });
    document.querySelectorAll(".netto-schalter").forEach(function (b) {
      b.setAttribute("aria-pressed", netto ? "true" : "false"); b.textContent = netto ? "Preise ohne MwSt. ✓" : "Preise ohne MwSt. zeigen";
    });
  }
  document.addEventListener("click", function (e) {
    if (!e.target.closest(".netto-schalter")) return;
    netto = !netto; try { localStorage.setItem("cm_netto", netto ? "1" : "0"); } catch (x) {}
    preise(); toast(netto ? "Preise ohne MwSt." : "Preise inkl. MwSt.");
  });
  if (netto) preise();
  // Schnellbestell-Liste
  function listeMengen() {
    var m = [];
    document.querySelectorAll(".l-menge").forEach(function (f) { var n = parseInt(f.value, 10) || 0; if (n > 0) m.push({id: +f.dataset.v, quantity: n, n: f.dataset.n, m: f.dataset.m}); });
    return m;
  }
  document.addEventListener("input", function (e) {
    var f = e.target.closest(".l-menge"); if (f) f.closest("tr").classList.toggle("gewaehlt", (parseInt(f.value, 10) || 0) > 0);
  });
  var lk = document.getElementById("liste-korb");
  if (lk) lk.addEventListener("click", function () {
    var m = listeMengen();
    if (!m.length) { toast("Bitte erst eine Menge eintragen"); return; }
    hinzu(m.map(function (x) { return {id: x.id, quantity: x.quantity}; }), m.length + (m.length === 1 ? " Produkt" : " Produkte") + " im Warenkorb", lk);
  });
  var la = document.getElementById("liste-anfrage");
  if (la) la.addEventListener("click", function () {
    var m = listeMengen(), feld = document.getElementById("bedarf");
    if (!m.length) { toast("Bitte erst eine Menge eintragen"); return; }
    if (feld) feld.value = m.map(function (x) { return x.quantity + " × " + x.n + (x.m ? " (" + x.m + ")" : ""); }).join("\n");
    var ziel = document.getElementById("anfrage");
    if (ziel) { ziel.scrollIntoView({behavior: ruhig ? "auto" : "smooth", block: "start"}); setTimeout(function () { feld && feld.focus({preventScroll: true}); }, ruhig ? 0 : 450); }
  });
  // Kopfleiste bekommt beim Scrollen eine feine Linie
  var kopf = document.querySelector(".nav");
  function kopfZeigen() { if (kopf) kopf.classList.toggle("gescrollt", window.scrollY > 8); }
  window.addEventListener("scroll", kopfZeigen, {passive: true}); kopfZeigen();
  // Laufband anhalten/fortsetzen (WCAG 2.2.2)
  document.querySelectorAll(".band .pause").forEach(function (b) {
    b.addEventListener("click", function () {
      var band = b.closest(".band"), steht = band.classList.toggle("steht");
      b.setAttribute("aria-pressed", steht ? "true" : "false");
      b.setAttribute("aria-label", steht ? "Laufband fortsetzen" : "Laufband anhalten");
      b.innerHTML = steht ? '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M7 5l12 7-12 7z"/></svg>'
                          : '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>';
    });
  });
  if (ruhig || !("IntersectionObserver" in window)) {
    document.querySelectorAll(".auf").forEach(function (el) { el.classList.add("da"); });
    return;
  }
  var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("da"); io.unobserve(x.target); } }); }, {threshold: .12});
  document.querySelectorAll(".auf").forEach(function (el) { io.observe(el); });
  // gestaffeltes Einblenden (Inhalt ohne JS sichtbar: Klasse kommt erst hier)
  var GRUPPEN = ".raster>.karte,.leistungen>.leistung,.branchen-raster>.branche,.zahlen>div,.tabelle>div,.faq>details,.schritte>li,.vorteile>div,.fragen-b2b>details,.wege>a,.block .h2,.block .eyebrow,.seitenkopf .lead";
  document.querySelectorAll(GRUPPEN).forEach(function (el) {
    if (el.closest(".auf")) return;
    var i = Array.prototype.indexOf.call(el.parentNode.children, el);
    el.style.setProperty("--i", i % 6); el.classList.add("zeig"); io.observe(el);
  });
  // Zähler (Endwert steht im HTML)
  var zio = new IntersectionObserver(function (es) {
    es.forEach(function (x) {
      if (!x.isIntersecting) return; zio.unobserve(x.target);
      var el = x.target, ziel = parseInt(el.dataset.zahl, 10), vor = el.dataset.vor || "", t0 = null;
      function schritt(t) {
        if (!t0) t0 = t; var p = Math.min(1, (t - t0) / 900), w = Math.round(ziel * (1 - Math.pow(1 - p, 3)));
        el.textContent = vor + w.toLocaleString("de-DE"); if (p < 1) requestAnimationFrame(schritt);
      }
      requestAnimationFrame(schritt);
    });
  }, {threshold: .6});
  document.querySelectorAll("[data-zahl]").forEach(function (el) { zio.observe(el); });
})();
